/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiChannelItem } from '../../asyncapi/models/AaiChannelItem';
import { AaiOperation } from '../../asyncapi/models/AaiOperation';
import { Aai20NodeFactory } from '../../asyncapi/v2/models/Aai20NodeFactory';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { DeleteNodeCommand } from './DeleteNodeCommand';
import { NodePath } from '../../core/models/NodePath';

/**
 * A command used to delete an operation to a Channel.
 * @author laurent.broudoux@gmail.com
 * @extends DeleteNodeCommand
 * @class
 */
export class DeleteOperationCommand_Aai20 extends DeleteNodeCommand<AaiOperation> {
    public constructor(opType? : any, channelItem? : any) {
        if(((typeof opType === 'string') || opType === null) && ((channelItem != null && channelItem instanceof <any>Node) || channelItem === null)) {
            let __args = arguments;
            super(opType, channelItem);
        } else if(opType === undefined && channelItem === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see DeleteNodeCommand#readNode(Document, Object)
     * @param {Document} doc
     * @param {*} node
     * @return {AaiOperation}
     */
    readNode(doc : Document, node : any) : AaiOperation {
        let channelItem : AaiChannelItem = <AaiChannelItem>this._parentPath.resolve(doc);
        let nodeFactory : Aai20NodeFactory = new Aai20NodeFactory();
        let operation : AaiOperation = nodeFactory.createOperation(channelItem, this._property);
        Library.readNode(node, operation);
        return operation;
    }
}
DeleteOperationCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteOperationCommand_Aai20";
DeleteOperationCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




